<template>
    <td-dialog :title="title" :before-close="customRoleDialogClose" :visible.sync="dialogCustomRoleVisible" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formCustomRoleInfo" ref="formCustomRoleInfo" :label-width="formLabelWidth" :rules="rules">
            <el-row>
                <el-form-item :label="$t('customRoleType.ROLE_TYPE_ID')" prop="iTypeId">
                    <td-input-number v-model="formCustomRoleInfo.iTypeId" :min="0" :disabled="isEdit" :placeholder="1" @change="changeRoleType"></td-input-number>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.ROLE_TYPE_NAME')" prop="sName">
                    <td-input v-model="formCustomRoleInfo.sName" maxlength="50"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.ROLE_TRIMMING_NAME')" prop="sTypeTitle">
                    <td-input v-model="formCustomRoleInfo.sTypeTitle" maxlength="50"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.TRIMMING_SERVICE_NAME')" prop="sTypeService">
                    <td-input v-model="formCustomRoleInfo.sTypeService" maxlength="50"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.TRIMMING_COTENT_QUERY_INTERFACE')" prop="sTypeApi">
                    <td-input v-model="formCustomRoleInfo.sTypeApi" maxlength="50"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.REF_OBJ_NAME_INTERFACE')" prop="sResNameApi">
                    <td-input v-model="formCustomRoleInfo.sResNameApi" maxlength="50"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.TRIMMING_PAGRAPI')" prop="sPageApi">
                    <td-input v-model="formCustomRoleInfo.sPageApi" maxlength="50"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.ROLE_FUNCTION_SETTING')" prop="groupQueryInterface">
                    <el-row>
                        <td-checkbox v-model="formCustomRoleInfo.iMenuManager" @change="changeMenuManager" trueLabel="1" falseLabel="0"></td-checkbox>
                        <span class="paddingLeft10">{{ $t('customRoleType.ALLOW_MANAGER_MENU') }}</span>
                    </el-row>
                    <el-row>
                        <td-checkbox v-model="formCustomRoleInfo.iResManager" @change="changeResManager" trueLabel="1" falseLabel="0"></td-checkbox>
                        <span class="paddingLeft10">{{ $t('customRoleType.ALLOW_MANAGER_REF_OPERATE') }}</span>
                    </el-row>
                    <el-row>
                        <td-checkbox v-model="formCustomRoleInfo.iShowUse" @change="changeShowUse" trueLabel="1" falseLabel="0"></td-checkbox>
                        <span class="paddingLeft10">{{ $t('customRoleType.ALLOW_VIEW_REF') }}</span>
                    </el-row>
                    <el-row>
                        <td-checkbox v-model="formCustomRoleInfo.iShowUnuse" @change="changeShowUnuse" trueLabel="1" falseLabel="0"></td-checkbox>
                        <span class="paddingLeft10">{{ $t('customRoleType.FORBID_VIEW_REF') }}</span>
                    </el-row>
                    <el-row>
                        <td-checkbox v-model="formCustomRoleInfo.iResGroup" @change="changeResGroup" trueLabel="1" falseLabel="0"></td-checkbox>
                        <span class="paddingLeft10">{{ $t('customRoleType.ALLOW_REF_GROUP') }}</span>
                    </el-row>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.GROUP_REF_QUERY_INTERFACE')" prop="sResGroupApi">
                    <td-input v-model="formCustomRoleInfo.sResGroupApi" maxlength="50"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('customRoleType.GROUP_REF_QUERY_RES_TYPE')" prop="sGroupResType">
                    <td-input v-model="formCustomRoleInfo.sGroupResType" maxlength="100"></td-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('common.DESCRIPTION')" :label-width="formLabelWidth" prop="sDescription">
                    <td-input type="textarea" v-model="formCustomRoleInfo.sDescription" :maxlength="100"></td-input>
                </el-form-item>
            </el-row>
        </el-form>
        <span slot="footer"
            ><td-button v-if="isShowSave" type="primary" @click="submitForm('formCustomRoleInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="customRoleDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import customRole from '../assets/api.js';
export default {
    // 初始化渲染
    components: {},
    props: ['title', 'dialogCustomRoleVisible', 'isEdit', 'editData', 'isShowSave'],
    created() {},
    mounted() {
        this.initData();
    },
    // 定义变量
    data() {
        return {
            permissionsAdd: ['role:add'],
            permissionsEdit: ['role:edit'],
            permissionsView: ['role:view'],
            permissionsDel: ['role:del'],
            formCustomRoleInfo: {
                sId: '',
                iTypeId: 3,
                sName: '',
                sTypeService: '',
                sTypeApi: '',
                sPageApi: '',
                sTypeTitle: '',
                sDescription: '',
                iMenuManager: 0,
                iResManager: 0,
                iResGroup: 0,
                iShowUse: 0,
                iShowUnuse: 0,
                sResGroupApi: '',
                sGroupResType: '',
                sResNameApi: ''
            },
            formLabelWidth: '40%',
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                iTypeId: [{ required: true, message: this.$t('roleError.ERROR_EMPTY'), trigger: 'blur' }],
                sName: [
                    { required: true, message: this.$t('roleError.ERROR_EMPTY'), trigger: 'blur' }
                    // { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL')}
                ],
                sTypeTitle: [
                    { required: true, message: this.$t('roleError.ERROR_EMPTY'), trigger: 'blur' }
                    // { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL')}
                ],
                sTypeService: [
                    { required: true, message: this.$t('roleError.ERROR_EMPTY'), trigger: 'blur' }
                    // { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL')}
                ],
                sTypeApi: [
                    { required: true, message: this.$t('roleError.ERROR_EMPTY'), trigger: 'blur' }
                    // { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL')}
                ],
                sResNameApi: [
                    { required: true, message: this.$t('roleError.ERROR_EMPTY'), trigger: 'blur' }
                    // { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL')}
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        initData() {
            if (this.isEdit || !this.isShowSave) {
                this.formCustomRoleInfo.iTypeId = this.editData.iTypeId;
                this.formCustomRoleInfo.sName = this.editData.sName;
                this.formCustomRoleInfo.sTypeTitle = this.editData.sName;
                this.formCustomRoleInfo.sTypeApi = this.editData.sTypeApi;
                this.formCustomRoleInfo.sTypeService = this.editData.sTypeService;
                this.formCustomRoleInfo.sDescription = this.editData.sDescription;
                this.formCustomRoleInfo.iMenuManager = this.editData.iMenuManager == 1 ? true : false;
                this.formCustomRoleInfo.iResManager = this.editData.iResManager == 1 ? true : false;
                this.formCustomRoleInfo.iResGroup = this.editData.iResGroup == 1 ? true : false;
                this.formCustomRoleInfo.iShowUse = this.editData.iShowUse == 1 ? true : false;
                this.formCustomRoleInfo.iShowUnuse = this.editData.iShowUnuse == 1 ? true : false;
                this.formCustomRoleInfo.sResGroupApi = this.editData.sResGroupApi;
                this.formCustomRoleInfo.sGroupResType = this.editData.sGroupResType;
                this.formCustomRoleInfo.sResNameApi = this.editData.sResNameApi;
                this.formCustomRoleInfo.sPageApi = this.editData.sPageApi;
            }
        },
        changeRoleType(val) {
            this.formCustomRoleInfo.iTypeId = val;
        },
        changeMenuManager(val) {
            this.formCustomRoleInfo.iMenuManager = val;
        },
        changeResManager(val) {
            this.formCustomRoleInfo.iResManager = val;
        },
        changeShowUse(val) {
            this.formCustomRoleInfo.iShowUse = val;
        },
        changeShowUnuse(val) {
            this.formCustomRoleInfo.iShowUnuse = val;
        },
        changeResGroup(val) {
            this.formCustomRoleInfo.iResGroup = val;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let content = this.formCustomRoleInfo;
                    if (!this.isEdit) {
                        customRole.addRoleTypeInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode == this.$common.requestCode.API_COMMON_ERR_DB_EXIST) {
                                this.$message({ showClose: true, message: this.$t('common.ROLE_TYPE_NUM_IS_EXIST'), type: 'warning' });
                            } else if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('roleType/addRoleTypeInfo', response.data.statusMessage);
                                this.loading = false;
                                return;
                            } else {
                                this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                                this.loading = false;
                                this.$emit('onSuccess');
                                this.customRoleDialogClose();
                            }
                        });
                    } else {
                        this.formCustomRoleInfo.sId = this.editData.sId;
                        customRole.modifyRoleTypeInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode == this.$common.requestCode.API_COMMON_ERR_DB_EXIST) {
                                this.$message({ showClose: true, message: this.$t('common.ROLE_TYPE_NUM_IS_EXIST'), type: 'warning' });
                            } else if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/roleType/modifyRoleTypeInfo', response.data.statusMessage);
                                this.loading = false;
                                return;
                            } else {
                                this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                                this.loading = false;
                                this.$emit('onSuccess');
                                this.customRoleDialogClose();
                            }
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        customRoleDialogClose() {
            this.$emit('customRoleDialogClose');
            this.$refs['formCustomRoleInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.paddingLeft10 {
    padding-left: 10px;
}
</style>
